import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { renderApplicantOptionMin, searchApplicantStatusFormatter, statusFormatter } from '../../../utils/formatters';
import { AUTO_ACCEPT_APPLICANT_STATUS, AUTO_ACCEPT_APPLICANT_STATUS_NAMES, PROCEDURE_TYPE } from '../../../configs';
import ApplicantDTO from '../../../dto/ApplicantDTO';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import CustomSelectInputWithHelper from '../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import { acceptApplicant, loadApplicantList } from '../actions';
import { getApplicationData } from '../reducer';
import Loader from '../../../components/base/Loader/Loader';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { getResponseError, setApplicant, setFields } from '../../../utils/utils';
import renderMessage from '../../../components/fields/renderMessage';

export default function AutoAcceptApplicant(props) {
  const {
    getValues, control, prefix = '', loadApplication = () => {}, procedure, setValue = () => {},
  } = props;
  const dto = new ApplicantDTO();
  const attributes = dto.getAttributesByName();
  const dispatch = useDispatch();
  const {
    currentApplication,
    loadingAcceptApplicant,
  } = useSelector(getApplicationData);

  const handleAccept = () => {
    dispatch(acceptApplicant({ id: currentApplication.id, applicant_id: getValues('applicant_id') }))
      .then(() => {
        loadApplication();
        successNotification('Подтверждение заявителя', 'Успешно');
      })
      .catch(response => errorNotification('Подтверждение заявителя', getResponseError(response)));
  };

  const optionFormatter = item => ({
    value: item.id, name: item.full_name, applicant: item, legal_entity_type: item?.legal_entity_type,
  });

  const onSelectApplicant = item => {
    const { applicant } = item;
    if (applicant === undefined) {
      return;
    }
    setValue('applicant.isMatch', false);
    setApplicant(applicant, setValue);

    if ([PROCEDURE_TYPE.PROCEDURE_1227_2, PROCEDURE_TYPE.PROCEDURE_1227_4, PROCEDURE_TYPE.PROCEDURE_1227_5, PROCEDURE_TYPE.PROCEDURE_1227_3].includes(procedure)) {
      if (procedure === PROCEDURE_TYPE.PROCEDURE_1227_5) {
        const fields1 = [
          'carriage_contract_number',
          'carriage_contract_effective_date',
          'carriage_contract_expiration_date',
          'driver_license_series',
          'driver_license_number',
          'driver_license_issue_date',
          'driver_license_expiration_date',
        ];
        setFields(applicant, prefix, fields1, setValue);
      }
    }
    const fields2 = [
      'effective_date',
      'expiration_date',
    ];
    setFields(applicant, prefix, fields2, setValue);
    if (procedure === PROCEDURE_TYPE.PROCEDURE_1228_3) {
      const fields3 = [
        'web_site',
        'software_names',
        'database_address',
        'server_address',
        'order_receiving_methods',
      ];
      setFields(applicant, prefix, fields3, setValue);
    }

    if (procedure === PROCEDURE_TYPE.PROCEDURE_1227_8) {
      const fields4 = [
        'vehicle_brand',
        'vehicle_model',
        'vehicle_year',
        'vehicle_color',
        'vehicle_lpn',
        'vehicle_vin',
        'vehicle_registration_number',
        'vehicle_registration_issue_date',
        'ecology_class',
        'applicant_car_cd_file',
        'car_photo_file',
        'has_special_lifting_device',
        'ownership_contract_number',
        'ownership_type',
        'ownership_contract_effective_date',
        'ownership_contract_expiration_date',
        'ownership_contract_files',
      ];
      setFields(applicant, prefix, fields4, setValue);
    }
  };

  const customToggleContent = (props, value, options, anchorElement, loader, selected) => {
    const {
      label,
      isRequired,
      fieldState = {
        error: '',
      },
    } = props;
    const { error } = fieldState;
    const isError = Boolean(error);
    const item = [...options, ...selected].find(option => option.value === value);
    return (
      <div className="form-control-wrapper material auto-accept-applicant-input" ref={anchorElement}>
        <div className={classNames('input-block', { 'is-invalid': isError })} title={renderMessage(label)}>
          {renderApplicantOptionMin(item)}
          <div htmlFor={props.id} className="form-input-label">
            {isRequired ? <span className="form-label-mark-required">*</span> : null}
            {renderMessage(label)}
          </div>
          <span className="input-after-block select-loader">
            <Loader loading={loader} />
            <div className="select-arrow-wrapper">
              <Icons customIcon className="select-arrow" width={12} height={8} icon="arrow-down" />
            </div>
          </span>
        </div>
        {isError ? <div className="invalid-feedback">{renderMessage(error)}</div> : null}
      </div>

    );
  };
  const status = currentApplication.applicant_status;
  const status_label = currentApplication.applicant_status_label;
  return (
    <>
      <Loader loading={loadingAcceptApplicant} />
      <FieldDTO
        control={control}
        dtoObject={attributes.applicant_id}
        usePortal
        withLabel
        variant="material"
        component={CustomSelectInputWithHelper}
        portalClassName="executor-selector"
        className="mt-3"
        loadAction={loadApplicantList}
        customRenderOptions={renderApplicantOptionMin}
        optionFormatter={optionFormatter}
        customToggleContent={customToggleContent}
        filterName="search"
        onSelect={onSelectApplicant}
      />
      {currentApplication.id ? (
        <div className="auto-accept-applicant">
          <div
            className="auto-accept-status"
          >{searchApplicantStatusFormatter(status, 'auto.accept.applicant', AUTO_ACCEPT_APPLICANT_STATUS_NAMES)}
          </div>
          <div className="auto-accept-button">
            <Button
              onClick={handleAccept}
              disabled={status === AUTO_ACCEPT_APPLICANT_STATUS.HANDLE_ACCEPT}
              variant="link"
            >Подтвердить
            </Button>
          </div>
        </div>
      ) : null}

    </>
  );
}
